import type { PlantDetailFormType } from '@schema';
import { axiosService } from '@services';
import { Plant } from '@types';

import { API } from '../endPoints';

export default async function savePlantDetail(plant: Plant, formData: PlantDetailFormType) {
  const data = new FormData();
  data.append('plant_id', plant.plant_id);
  data.append('name', plant.name);

  if (formData.image instanceof File) {
    data.append('image', formData.image);
  }

  data.append('co2', formData.co2);
  data.append('currency', formData.reimbursement);

  if(typeof formData.isActive === 'boolean') {
    data.append('is_active', String(formData.isActive));
  }

  return axiosService({ method: 'post', apiPath: API.PLANT_DATA, data });
}
